module.exports = __webpack_public_path__ + "img/Z86_12.a2dd1295.jpg";